/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  iceColumnDefinition,
  SECTION_CONTROL_ALIGNMENT,
  IceResponsiveMattableSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MatTableDataSource } from '@angular/material';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { XmlparseService } from '../../../../icemedx-lib/src/services/xml/xmlparse.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { LoginConfig } from '../../../../icemedx-lib/src/login/login.config';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { messagereference } from 'projects/icemedx-lib/src/models/messages/messagereference';
import { LazyLoadManager } from '../../../../icemedx-lib/src/components/models/lazyload.manager';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { user } from 'projects/icemedx-lib/src/models/common/user';

declare var require: any;

enum MessageActionTypes {
  Unread = 1,
  Read = 2,
  Processed = 3,
  FlagMessage = 4,
  Delete = 5
}

@Component({
  selector: 'messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  providers: [IcepanelService, MessageService, XmlparseService, IceNavService, AppService]
})
export class MessagesComponent implements OnInit {

  // Data Members
  inboxTableSettings: IceResponsiveMattableSettings;
  messageDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([])
  lazyLoadMgr: LazyLoadManager = null;
  membersToMap: any = {};

  // Control Settings
  messageViewSettings: IcepanelcontainerSettings = null;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private appSvc: AppService,
    private msgService: MessageService,
    private navSvc: IceNavService,
    private domainService: DomainService,
    private messageService: MessageService) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Messages", {}, true, "");
    this.InitComponent();
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  ///////////////////////
  // private functions //
  ///////////////////////

  private InitComponent() {
    this.route.params.subscribe(params => {
      this.loadMessages(params['value']);
    });
  }

  routeToBox(rteVal: string): IceTypes.MessageboxTypes {
    switch (rteVal) {
      case "deleted": return IceTypes.MessageboxTypes.mboxDELETED;
      case "drafts": return IceTypes.MessageboxTypes.mboxDRAFTS;
      case "inbox": return IceTypes.MessageboxTypes.mboxINBOX;
      case "invitations": return IceTypes.MessageboxTypes.mboxINVITE;
      case "processed": return IceTypes.MessageboxTypes.mboxDELETED;
      case "sent": return IceTypes.MessageboxTypes.mboxSENT;
      case "action-items": return IceTypes.MessageboxTypes.mboxPOSTS; // only for action items
      case "hie-trans": return IceTypes.MessageboxTypes.mboxTRANSBOX;
    }
    return IceTypes.MessageboxTypes.mboxINBOX;
  }

  private loadMessages(routeVal: string) {
    if (!Iceutility.isdefined(routeVal)) {
      routeVal = "inbox"; // to handle "wapp/messages" URL when mbox is not present
    }

    let mbox: IceTypes.MessageboxTypes = this.routeToBox(routeVal);
    this.renderView(Iceutility.stringCapitalize(routeVal));

    // Retrieve messages
    this.msgService.getMessages(mbox).subscribe(data => {
      let msgToShow: messagereference[] = [];

      if (mbox == IceTypes.MessageboxTypes.mboxPOSTS) {
        let msgrefs: messagereference[] = <messagereference[]>data;
        for (let index = 0; index < msgrefs.length; index++) {
          if (msgrefs[index] == null) continue;
          if (msgrefs[index].trans_type == IceTypes.TRANSTYPE.itAlarm) {
            msgToShow.push(msgrefs[index]);
          }
        }
      }
      else {
        msgToShow = <messagereference[]>data;
      }

      this.lazyLoadMgr = new LazyLoadManager(msgToShow, msgToShow != null ? msgToShow.length : 50);
      this.lazyLoadMgr.processData(true).subscribe(
        lazyLoadData => {
          this.getLazyLoad(lazyLoadData);
        },
        lazyLoadError => {
          this.inboxTableSettings.loadingIndicator = false;
          console.log(lazyLoadError);
        });

    }, error => {
      this.messageDataSource.data = [];
      this.inboxTableSettings.loadingIndicator = false;
      this.lazyLoadMgr = new LazyLoadManager([], 50);
      console.log(JSON.stringify(this.msgService.getLastErrors()));
    });
  }

  private renderView(panelHeader: string): void {
    if (!Iceutility.isdefined(panelHeader)) {
      return;
    }

    this.messageDataSource.data = [];

    let panelTag = panelHeader;
    let panelKey = Iceutility.guid(false);
    this.inboxTableSettings = new IceResponsiveMattableSettings(
      "InboxTable",
      [
        new iceColumnDefinition("Actions", "Actions", false, false, null),
        new iceColumnDefinition("From", "From", false),
        new iceColumnDefinition("Subject", "Subject", false),
        new iceColumnDefinition("Date of Message", "Date of Message", false),
        new iceColumnDefinition("Domain Origin", "Domain Origin", false, false, null, false),
        new iceColumnDefinition("Key", "Key", true),
      ],
      this.messageDataSource,
      [
        { name: "Unread", value: MessageActionTypes.Unread },
        { name: "Read", value: MessageActionTypes.Read },
        { name: "Processed", value: MessageActionTypes.Processed },
        { name: "Flag Message", value: MessageActionTypes.FlagMessage },
        { name: "Delete", value: MessageActionTypes.Delete }
      ],
      true,
      null, false, null, true
    );

    let tables: IceResponsiveMattableSettings[] = [
      this.inboxTableSettings
    ];
    let groups: IcepanelgroupSettings[] = [
      new IcepanelgroupSettings(null, tables)
    ];

    let statues = [
      { value: "-1", name: "All" },
      { value: IceTypes.trans_status.isAccepted.toString(), name: MessageService.getStatus(IceTypes.trans_status.isAccepted) },
      { value: IceTypes.trans_status.isApproved.toString(), name: MessageService.getStatus(IceTypes.trans_status.isApproved) },
      { value: IceTypes.trans_status.isDenied.toString(), name: MessageService.getStatus(IceTypes.trans_status.isDenied) },
      { value: IceTypes.trans_status.isError.toString(), name: MessageService.getStatus(IceTypes.trans_status.isError) },
      { value: IceTypes.trans_status.isNone.toString(), name: MessageService.getStatus(IceTypes.trans_status.isNone) },
      { value: IceTypes.trans_status.isPending.toString(), name: MessageService.getStatus(IceTypes.trans_status.isPending) },
      { value: IceTypes.trans_status.isPrinted.toString(), name: MessageService.getStatus(IceTypes.trans_status.isPrinted) },
      { value: IceTypes.trans_status.isRead.toString(), name: MessageService.getStatus(IceTypes.trans_status.isRead) },
      { value: IceTypes.trans_status.isReadyToSend.toString(), name: MessageService.getStatus(IceTypes.trans_status.isReadyToSend) },
      { value: IceTypes.trans_status.isReadyToPrint.toString(), name: MessageService.getStatus(IceTypes.trans_status.isReadyToPrint) },
      { value: IceTypes.trans_status.isReceived.toString(), name: MessageService.getStatus(IceTypes.trans_status.isReceived) },
      { value: IceTypes.trans_status.isRejected.toString(), name: MessageService.getStatus(IceTypes.trans_status.isRejected) },
      { value: IceTypes.trans_status.isReSent.toString(), name: MessageService.getStatus(IceTypes.trans_status.isReSent) },
      { value: IceTypes.trans_status.isUnRead.toString(), name: MessageService.getStatus(IceTypes.trans_status.isUnRead) },
    ];

    let controls: IcecontrolSettings[] = [
      new IcecontrolSettings("iceinput", { width: "204px" }, null, null, "", "Enter keyword"),
      new IcecontrolSettings("iceselect", { menuItems: statues, width: "204px" }, null, null, "", "Select type"),
      new IcecontrolSettings("icedatepicker", {}, null, null, "", "Select a date"),
      new IcecontrolSettings("icedatepicker", {}, null, null, "", "Select a date"),
      new IcecontrolSettings("icebutton", { text: "Search", class: [], glyphClass: "fa-search" }, null, null)
    ];
    let filterSections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("MessageSection", { class: [], styles: {} }, groups, null/*controls*//*hide for this version*/, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal)
    ];

    let panels: IcepanelSettings[] = [
      new IcepanelSettings(panelTag, panelKey, panelTag, "", filterSections)];

    let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
    this.messageViewSettings = new IcepanelcontainerSettings(panelTag, panelrows);
  }

  getLazyLoad(lzData): any[] {
    let dataToLoad = [];
    for (let index = 0; index < lzData.length; index++) {
      let obj = {};
      let message = lzData[index];
      if (!Iceutility.isdefined(message)) {
        continue;
      }

      let tempmemid = message["from"].toLowerCase();
      let mappedMember: user = <user>DomainService.mappedMembers[tempmemid];
      if (mappedMember == null) {
        if (this.membersToMap[tempmemid] == null)
          this.membersToMap[tempmemid] = [];

        this.membersToMap[tempmemid].push(obj);
      }

      obj["actions"] = "";
      obj["From"] = mappedMember ? mappedMember.getdisplayname() : message["from"];
      obj["Subject"] = message["subject"];
      obj["Date of Message"] = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(message["message_date"]));
      obj["Domain Origin"] = "";
      obj["Key"] = message["message_key"];

      dataToLoad.push(obj);
    }

    if (this.messageDataSource.data.length > 0) {
      this.messageDataSource.data.concat(dataToLoad);
    } else {
      this.messageDataSource.data = dataToLoad;
    }
    this.inboxTableSettings.loadingIndicator = false;
    let msgComp: MessagesComponent = this; 
    let mems = Object.keys(this.membersToMap);
    if (mems.length > 0) {
      this.domainService.mapMembers(mems.join(",")).subscribe(
        data => {
          if (data == null) return;
          for (let imem = 0; imem < data.length; imem++) {
            let mem = <user>data[imem];

            let tempmemid = mem.login_user_name.toLowerCase();
            let msgAry = msgComp.membersToMap[tempmemid];
            if (msgAry == null) continue;

            let fromName = mem.getdisplayname();
            for (let imsg = 0; imsg < msgAry.length; imsg++) {
              let msg = msgAry[imsg];
              if (msg == null) continue;
              msg["From"] = fromName;
            }
          }
          msgComp.membersToMap = {}; // reset temp
        },
        error => {
          console.log(JSON.stringify(this.messageService.getLastErrors()));
        });
    }

    return dataToLoad;
  }

  onTableLazyLoad(event) {
    if (this.lazyLoadMgr == null) return;

    this.lazyLoadMgr.processData(false).subscribe(
      lazyLoadData => {
        this.getLazyLoad(lazyLoadData);
      },
      lazyLoadError => {
        console.log(lazyLoadError);
      });
  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }
    this.router.navigate([this.navSvc.buildRoute("viewmessage/" + event.rowData.Key, false)]);
  }

  onMatGridRowActionClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }
    this.router.navigate([this.navSvc.buildRoute("viewmessage/" + event.rowData.Key, false)]);
  }
}
